import React from 'react';

const CalendarSkeleton = () => {
  return (
    <div style={{ 
      height: '100%', 
      border: '1px solid #ddd', 
      borderRadius: '5px',
      backgroundColor: '#fff',
      overflow: 'hidden'
    }}>
      {/* Calendar Header Skeleton */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 20px',
        borderBottom: '1px solid #ddd',
        backgroundColor: '#f8f9fa'
      }}>
        <div style={{
          width: '80px',
          height: '30px',
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          animation: 'skeleton-loading 1.5s infinite'
        }}></div>
        <div style={{
          width: '200px',
          height: '35px',
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          animation: 'skeleton-loading 1.5s infinite'
        }}></div>
        <div style={{
          width: '80px',
          height: '30px',
          backgroundColor: '#e0e0e0',
          borderRadius: '4px',
          animation: 'skeleton-loading 1.5s infinite'
        }}></div>
      </div>

      {/* Week Days Header */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        borderBottom: '1px solid #ddd',
        backgroundColor: '#fafafa'
      }}>
        {[...Array(7)].map((_, i) => (
          <div key={i} style={{
            padding: '10px',
            textAlign: 'center',
            borderRight: i < 6 ? '1px solid #ddd' : 'none'
          }}>
            <div style={{
              width: '60px',
              height: '20px',
              margin: '0 auto',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              animation: 'skeleton-loading 1.5s infinite',
              animationDelay: `${i * 0.1}s`
            }}></div>
          </div>
        ))}
      </div>

      {/* Calendar Grid */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gridTemplateRows: 'repeat(5, 1fr)',
        height: 'calc(100% - 110px)'
      }}>
        {[...Array(35)].map((_, i) => (
          <div key={i} style={{
            padding: '10px',
            borderRight: (i + 1) % 7 !== 0 ? '1px solid #ddd' : 'none',
            borderBottom: i < 28 ? '1px solid #ddd' : 'none',
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
          }}>
            {/* Date Number Skeleton */}
            <div style={{
              width: '30px',
              height: '20px',
              backgroundColor: '#e0e0e0',
              borderRadius: '4px',
              animation: 'skeleton-loading 1.5s infinite',
              animationDelay: `${(i % 7) * 0.1}s`
            }}></div>
            
            {/* Event Skeleton (randomly show some) */}
            {i % 3 === 0 && (
              <div style={{
                width: '100%',
                height: '25px',
                backgroundColor: '#d0d0d0',
                borderRadius: '4px',
                animation: 'skeleton-loading 1.5s infinite',
                animationDelay: `${(i % 7) * 0.15}s`
              }}></div>
            )}
            {i % 5 === 0 && (
              <div style={{
                width: '80%',
                height: '25px',
                backgroundColor: '#d0d0d0',
                borderRadius: '4px',
                animation: 'skeleton-loading 1.5s infinite',
                animationDelay: `${(i % 7) * 0.2}s`
              }}></div>
            )}
          </div>
        ))}
      </div>

      <style>
        {`
          @keyframes skeleton-loading {
            0% {
              opacity: 0.6;
            }
            50% {
              opacity: 1;
            }
            100% {
              opacity: 0.6;
            }
          }
        `}
      </style>
    </div>
  );
};

export default CalendarSkeleton;

